import React from "react";
import classes from "./style/UI_ModuleTextDownCard.module.css";
import { nanoid } from "@reduxjs/toolkit";

interface UI_ModuleTextDownCard {
  textDown: string[];
}

export const UI_ModuleTextDownCard: React.FC<UI_ModuleTextDownCard> = (
  props
) => {
  const { textDown } = props;
  return (
    <div className={classes.cardTextDownWrapper}>
      {textDown?.map((item) => {
        const id = nanoid();
        return (
          <div className={classes.cardTextDown} key={id}>
            {item}
          </div>
        );
      })}
    </div>
  );
};
